import { render, staticRenderFns } from "./RoomDetailsModal.vue?vue&type=template&id=456e7d18&scoped=true&"
import script from "./RoomDetailsModal.vue?vue&type=script&lang=js&"
export * from "./RoomDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./RoomDetailsModal.vue?vue&type=style&index=0&id=456e7d18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456e7d18",
  null
  
)

export default component.exports